import React from 'react';

import { WIZARD_WIDTH_PX } from '../utils';
import type { ProgressIndicatorProps } from './types';
import MiniWizard from '../wizard-progress.png';
import styles from './styles.module.css';

const WIZARD_HALF_WIDTH = WIZARD_WIDTH_PX / 2;

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  percentage,
}) => {
  return (
    <img
      src={MiniWizard}
      alt=""
      className={styles.wizard}
      style={{ left: `calc(${percentage}% - ${WIZARD_HALF_WIDTH}px)` }}
      aria-hidden="true"
    />
  );
};
